// extracted by mini-css-extract-plugin
export var container = "_pt-0";
export var dotAnimation = "_pt-2";
export var dotsLoading = "_pt-1";